<template>
  <div id="app">
    <div class="editor">
      <creature-block :players="players" v-bind="creature" />
      <div class="right">
        <label for="name" class="form-element">
          <strong>Name:</strong>
          <input type="text" id="name" v-model="creature.name" />
        </label>
        <label for="detail" class="form-element">
          <strong>Detail:</strong>
          <input type="text" id="detail" v-model="creature.detail" />
        </label>
        <label for="level" class="form-element">
          <strong>Level:</strong>
          <input type="number" max="28" min="-3" id="level" v-model.number="creature.level" />
        </label>
        <label for="role" class="form-element">
          <strong>Role:</strong>
          <select id="role" v-model="creature.role">
            <option v-for="role in roles" :key="role" :value="role">{{role | capitalize}}</option>
          </select>
        </label>
        <label for="type" class="form-element">
          <strong>Type:</strong>
          <select id="type" v-model="creature.type">
            <option v-for="type in types" :key="type" :value="type">{{type | capitalize}}</option>
          </select>
        </label>

        <label for="traits" class="form-element">
          <strong>Traits:</strong>
          <multiselect v-model="creature.traits" multiple :options="traitKeys" :custom-label="traitLabel" />
        </label>
        <label for="powers" class="form-element">
          <strong>Powers:</strong>
          <multiselect v-model="creature.powers" multiple group-select :options="powerKeys" :custom-label="powerLabel" group-label="name" group-values="powers" />
        </label>

        <div class="save-load-bar">
          <button @click="saveCreature">Save</button>
          <button @click="showSave = true">Save JSON</button>
          <button @click="showLoad = true">Load JSON</button>
        </div>
      </div>
    </div>
    <hr />
    <creature-block v-for="c of creatures" :key="c.guid" :players="players" v-bind="c" />

    <modal v-if="showSave">
      <h3 slot="header">Save JSON</h3>
      <textarea slot="body" class="modal-textarea" :value="JSON.stringify(this.creatures, null, ' ')"></textarea>
      <template slot="footer">
        Copy the JSON
        <button class="modal-default-button" @click="showSave = false">
          OK
        </button>
      </template>
    </modal>
    <modal v-if="showLoad">
      <h3 slot="header">Load JSON</h3>
      <textarea slot="body" class="modal-textarea" v-model="loadJson"></textarea>
      <template slot="footer">
        Paste the JSON
        <button class="modal-default-button" @click="loadCreatures">
          OK
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
import CreatureBlock from './components/creature-block.vue';
import Multiselect from 'vue-multiselect';
import Modal from './components/modal.vue';

import traitData from './data/traits.json';
import powerData from './data/powers.json';

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export default {
  data() {
    return {
      players: 4,
      types: ['minion', 'standard', 'elite', 'solo'],
      roles: ['controller', 'defender', 'lurker', 'scout', 'sniper', 'striker', 'supporter'],
      traits: traitData,
      powers: powerData,

      showSave: false,
      showLoad: false,
      loadJson: '[]',

      creature: {
        name: 'Dragonborn Assassin',
        detail: 'Medium humanoid',
        level: 5,
        role: 'lurker',
        type: 'elite',
        traits: ['dragonbreath'],
        powers: ['backstab'],
        guid: uuidv4()
      },
      creatures: []
    };
  },
  computed: {
    traitKeys() {
      return ['multiattack', ...Object.keys(traitData).slice(5)];
    },
    powerKeys() {
      return this.roles.map(role => ({
        name: role[0].toUpperCase() + role.substr(1),
        powers: Object.keys(powerData).filter(power => powerData[power]['role'] == role)
      }));
    }
  },
  methods: {
    traitLabel(trait) {
      return this.traits[trait]['title'];
    },
    powerLabel(power) {
      return this.powers[power]['title'];
    },
    saveCreature() {
      let creature = Object.assign({}, this.creature);
      this.creatures.push(creature);
      this.creature.guid = uuidv4();
    },
    loadCreatures() {
      const goodKeys = Object.keys(this.creature);
      try {
        let creatures = JSON.parse(this.loadJson);
        if(Array.isArray(creatures)) {
          let good = creatures.every(creature => {
            const keys = Object.keys(creature);
            return keys.every(k => goodKeys.includes(k));
          });

          if(good) {
            this.creatures = creatures;
            this.loadJson = '[]';
            this.showLoad = false;
            return;
          }
        }
      } catch(e) {};
      alert("Unable to load, invalid JSON for creatures...");
    }
  },
  filters: {
    capitalize(value) {
      if(!value) return ''
      value = value.toString()
      return value[0].toUpperCase() + value.slice(1)
    }
  },
  components: {
    CreatureBlock,
    Multiselect,
    Modal
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
@import url('//fonts.googleapis.com/css?family=Roboto');

#app {
  & > hr {
    border: 0;
    background: #ccc;
    height: 1px;
  }
  .editor {
    display: flex;
  }
  .right {
    margin-top: 20px;

    .form-element {
      margin: 2px 0;
      display: block;

      strong {
        width: 70px;
        display: inline-block;
      }

      input, select {
        width: 180px;
      }
    }
  }

  .save-load-bar {
    margin-top: 10px;
  }

  .modal-textarea {
    width: 100%;
    height: 200px;
  }
}

.option__title {
  font-weight: bold;
  display: block;
}
.option__small {
  display: block;
  max-width: 100%;
  text-overflow: ellipsis;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/App.vue